import React from 'react';
// import { Route } from 'react-router-dom';

// components
import Header from './components/Header';
import Footer from './components/Footer';
import Main from './components/Main';

function App() {
  const contentOnly = (window.location.search.indexOf('contentonly') > -1) ? true : false;

  return (
    <>
      {(contentOnly === false) && ( <Header /> )}
      <Main />
      {(contentOnly === false) && ( <Footer /> )}
    </>
  );
}

export default App;